import { journeyAction, settingsFormSchema } from "./base";

import { JourneyActionSendTextMessage as JourneyActionTextMessageBase } from "atlas-shared";
import { FormElementTypes } from "atlas-form";

export const JourneyActionSendTextMessage = journeyAction({
  ...JourneyActionTextMessageBase,
  settings_form: settingsFormSchema({
    elements: [{ ref: "text_message_source_id" }, { ref: "phone_numbers" }, { ref: "body" }],
  }),
  initialValues: {
    body: "Hello, this is a test message",
    phone_numbers: [],
  },
  additionalParams: {
    properties_phone_numbers: {
      ui_type: FormElementTypes.LIST,
      label: "Phone Numbers",
      addText: "Add Phone Number",
      child_params: {
        ui_type: FormElementTypes.INPUT,
        data_type: "phone",
        placeholder: "Enter phone number",
      },
    },
    properties_body: {
      ui_type: FormElementTypes.TEXT_MESSAGE,
      hashOptions: ["contact", "agent"],
    },
  },
  icon: "Send",
});
